import { gsap } from 'gsap';
import { Outlet, useLocation } from 'react-router-dom';
import { Routes, Route } from 'react-router-dom';
import { ScrollTrigger, ScrollSmoother } from 'gsap/all';
import { useLayoutEffect, useRef, useEffect } from 'react';

import AboutUs from './pages/home/AboutUs';
import Apply from './pages/Apply.js';
import BBILogistics from './pages/home/BBILogistics';
import CareersAndServices from './pages/home/CareersAndServices';
import classes from './App.module.css';
import Footer from './layout/Footer.js';
import Home from './pages/home/Home';
import OurMission from './pages/home/OurMission';
import HeaderBanner from './layout/HeaderBanner.js';

gsap.registerPlugin(ScrollTrigger, ScrollSmoother);

export default function App() {
  const smootherRef = useRef();
  const location = useLocation();

  // Setup ScrollSmoother
  useLayoutEffect(() => {
    const mm = gsap.matchMedia();

    mm.add('(min-width: 800px)', () => {
      const ctx = gsap.context(() => {
        ScrollTrigger.normalizeScroll(true);

        smootherRef.current = ScrollSmoother.create({
          smooth: 0.75,
          smoothTouch: true,
          effects: true,
          normalizeScroll: true,
          ease: 1,
        });
      });

      return () => {
        ctx.revert();
        if (smootherRef.current) {
          smootherRef.current.kill();
          smootherRef.current = undefined;
        }
      };
    });

    return () => mm.kill();
  }, []);

  // Scroll after smoother is ready + location.state exists
  useEffect(() => {
    const scrollTo = location.state?.scrollTo;
    if (!scrollTo) return;

    let attempts = 0;
    const maxAttempts = 20;

    const interval = setInterval(() => {
      const el = document.getElementById(scrollTo);
      attempts++;

      if (el) {
        if (smootherRef.current?.scrollTo) {
          // Desktop with ScrollSmoother
          smootherRef.current.scrollTo(`#${scrollTo}`, true, 'top top+=100');
        } else {
          // Mobile fallback
          const y = el.getBoundingClientRect().top + window.scrollY - 100;
          window.scrollTo({ top: y, behavior: 'smooth' });
        }

        clearInterval(interval);
      }

      if (attempts >= maxAttempts) {
        clearInterval(interval);
        console.warn(`Could not find #${scrollTo} after ${maxAttempts} tries.`);
      }
    }, 100);

    return () => clearInterval(interval);
  }, [location]);

  const home = (
    <>
      <Home />
      <OurMission />
      <CareersAndServices />
      <AboutUs />
      <BBILogistics />
    </>
  );

  return (
    <Routes>
      <Route
        path='/'
        element={
          <div id='smooth-wrapper'>
            <HeaderBanner />
            <div className={classes.app} id='smooth-content'>
              <Outlet />
              <Footer />
            </div>
          </div>
        }
      >
        <Route index element={home} />
        <Route path='/applynow' element={<Apply />} />
      </Route>
    </Routes>
  );
}
